import { HttpService } from '../core/http/http.service';
import { Injectable } from '@angular/core';
import { IStoreFloor, IConcept, IConceptTemplate } from '../_entities';
import { IProfitLossArea } from '../project/entities/i-profit-loss-area';

@Injectable()
export class AreaPlannerService {

    constructor(private httpService: HttpService) { }

	public getAreaPlanForStore(storeId: number): Promise<IStoreFloor[]> {
		return this.httpService.get<IStoreFloor[]>(`api/store/${storeId}/storefloor`);
    }

	public getAreaPlanForProject(storeId: number, projectCode: string): Promise<IStoreFloor[]> {
		return this.httpService.get<IStoreFloor[]>(`api/store/${storeId}/project/${projectCode}/storefloor`);
	}

	public getAreaPlanSummary(storeId: number, projectCode: string): Promise<IProfitLossArea> {
		return this.httpService.get<IProfitLossArea>(`api/store/${storeId}/project/${projectCode}/areaplanner/summary`);
	}

	public getConceptTemplates(storeClassId: string): Promise<IConceptTemplate[]> {
		return this.httpService.get<IConceptTemplate[]>(`api/concepttemplates/${storeClassId}`);

	}

	public getStoreFloor(storeFloorId: number): Promise<IStoreFloor> {
		return this.httpService.get<IStoreFloor>(`api/storefloor/${storeFloorId}`);
	}

	public patchStoreFloor(storeFloorId: number, prop: string, value: any): Promise<IStoreFloor> {
		const patches = [{ "op": "replace", "path": `/${prop}`, "value": value }];
		return this.httpService.patch<IStoreFloor>(`api/storefloor/${storeFloorId}`, patches);
	}

	public async patchConcept(conceptId: number, prop: string, value: any): Promise<IConcept> {
		const patches = [{ "op": "replace", "path": `/${prop}`, "value": value }];
		return await this.httpService.patch<IConcept>(`api/concept/${conceptId}`, patches);
	}

	public addConcept(storeFloorId: number, conceptTypeId: number, areadata: any): Promise<IConcept> {
		areadata["storeFloorId"] = storeFloorId;
		areadata["conceptTypeId"] = conceptTypeId;
		console.dir(areadata);
		return this.httpService.post<IConcept>("api/concept", areadata);
	}




}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/area-planner.service.ts